import React, { useEffect, useState } from "react";
import { Row, Col, Layout, Menu, Drawer, Badge, Divider, Dropdown } from "antd";
import "./sideMenu.css";
import Logo from "../../assets/images/logo-sec.png";
import StLogo from "../../assets/images/trkrLogo.png";
import {
  FaHardHat,
  GiMineTruck,
  ImTruck,
  BsSoundwave,
  BsArrowLeftShort,
  HiOutlineDocumentDuplicate,
  RiLogoutBoxRLine,
  HiUserCircle,
  AiFillTool,
  AiOutlineMenu,
  AiFillBell,
  MdOutlineCreditCard,
  RiTruckLine,
} from "react-icons/all";
import { Link, useHistory, matchPath } from "react-router-dom";
import useMedia from "use-media";
import styled from "styled-components";
import HeaderImage from "../../assets/images/header.jpg";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { DashboardAction, UserAction } from "../../store/actions";
import HeaderComponent from "../header";
const { Header, Sider, Content } = Layout;

const SideMenuWrapper = styled(Sider)`
  flex: ${(props) =>
    props.collapsed ? "0 0 50px !important" : "0 0 200px !important"};
  min-width: ${(props) =>
    props.collapsed ? "60px !important" : "200px !important"};
  width: ${(props) =>
    props.collapsed ? "60px !important" : "200px !important"};
`;

function SideMenu(props) {
  const [collapsed, setCollapsed] = useState(true);
  const toggle = () => {
    setCollapsed(!collapsed);
  };
  const dispatch = useDispatch();
  const isWide = useMedia({ minWidth: 600 });
  const history = useHistory();
  const [isVisible, setIsVisible] = useState(false);

  const componentName = props.location.pathname;
  // const match = matchPath(props.location.pathname)
  const userName = useSelector((store) => store.AuthReducer.user);
  const userDetail = useSelector((store) => store.UserReducer?.userDetails);
  const plantkeyTab = useSelector(
    (store) => store.DashboardReducer?.plantkeyTab
  );
  const tabKey = useSelector((store) => store.CatalogReducer.keyTab);
  const splitedId =
    componentName.split("/")[componentName.split("/").length - 2];
  const companyUserProductId =
    componentName.split("/")[componentName.split("/").length - 1];
  const companyUserId =
    componentName.split("/")[componentName.split("/").length - 3];

  // const rmxUserId =
  //   componentName.split("/")[componentName.split("/").length - 2];

  const rmxId = componentName.split("/")[componentName.split("/").length - 2];

  const logisticsId =
    componentName.split("/")[componentName.split("/").length - 2];

  const plantId = componentName.split("/")[componentName.split("/").length - 2];
  console.log("userDetail===>", plantId);

  const notification = useSelector(
    (store) => store.DashboardReducer.notification
  );

  const companyDetails = useSelector(
    (store) => store.UserReducer.companyDetails
  );

  // const companyDetails = useSelector(
  //   (store) => store.UserReducer.companyDetails
  // );
  useEffect(() => {
    dispatch(UserAction.getCompantDetailReq());
  }, []);

  let addressName = "";
  console.log("match===>", splitedId);

  switch (componentName) {
    case "/dashboard":
      addressName = "Super Admin Dashboard";
      break;
    case "/contractors":
      addressName = "Customers";
      break;
    case "/rmx":
      addressName = "Asphalt Plants";
      break;
    case `/rmx/${plantId}/orders`:
      addressName = "Asphalt Plants";
      break;
    case "/logistics":
      addressName = "Logistics Partners";
      break;
    case `/logistics/${logisticsId}/orders`:
      addressName = "Logistics Partner";
      break;
    case "/employees":
      addressName = "Employees";
      break;
    case "/product":
      addressName = "Catalog";
      break;
    case `/product/${splitedId}/update`:
      addressName = "Update Product";
      break;
    case `/basemix/${splitedId}/update`:
      addressName = "Update Basemix";
      break;

    case `/additives/${splitedId}/update`:
      addressName = "Update Additive";
      break;
    case `/categories/${splitedId}/update`:
      addressName = "Update Category";
      break;
    case `/product/new`:
      addressName = "Create New Product";
      break;
    case `/basemix/new`:
      addressName = "Create New Basemix";
      break;

    case `/additives/new`:
      addressName = "Create New Additive";
      break;
    case `/categories/new`:
      addressName = "Create New Category";
      break;
    case `/rmx/${companyUserId}/orders/${companyUserProductId}`:
      addressName = "Order";
      break;
    case `/logistics/${companyUserId}/orders/${companyUserProductId}`:
      addressName = "Order";
      break;
    case "/account":
      addressName = "Account Settings";
      break;
    default:
      addressName = addressName;
  }

  console.log("addressName", addressName);
  let key = "";




  switch (componentName) {
    case "/dashboard":
      key = "1";

      break;
    case "/contractors":
      key = "2";

      break;
    case "/rmx":
      key = "3";

      break;
    case "/logistics":
      key = "4";

      break;
    case "/employees":
      key = "5";

      break;
    case "/product":
      key = "6";

      break;
    case "/account":
      key = "7";

      break;
    default:
      key = key;
  }
  console.log("keyTab==>", tabKey);
  const menu = (
    <Menu>
      {notification.map((item) => {
        return (
          <Row
            onClick={() => {
              !componentName.includes("order")
                ? history.push(`order/${item?.data?.order?.id}`)
                : history.push(`${item?.data?.order?.id}`);
              !item.is_read && dispatch(DashboardAction.isMarkReadReq(item.id));
            }}
            className="pointer-cursor"
            style={{
              backgroundColor: item.is_read ? "white" : "#F5F5F5",
              padding: "10px",
            }}
          >
            <Col xl={24} xs={24} className="d-flex align-item-middle">
              <Badge status="warning" />
              <span
                className="d-flex align-item-middle"
                style={{ fontSize: "11.5px" }}
              >
                You have a new order{" "}
                <strong style={{ marginLeft: "6px", fontSize: "14px" }}>
                  #{item?.data?.order?.order_number}
                </strong>
              </span>
            </Col>
            <Col span={2}></Col>
            <Col span={22}>
              <span style={{ fontSize: "12px" }}>
                {moment(item?.created_at).utc().fromNow()}
              </span>
            </Col>
            <Col span={24}>
              <Divider />{" "}
            </Col>
          </Row>
        );
      })}
    </Menu>
  );
  const markAsRead = notification.filter((item) => !item.is_read);
  return (
    <Layout>
      {!isWide ? (
        <Drawer
          placement="left"
          width="70%"
          onClose={toggle}
          visible={!collapsed}
          closeIcon={false}
          extra={
            <div>
              <img
                src={
                  collapsed ? StLogo : Logo
                }
                width={collapsed ? "42px" : "170px"}
                height={collapsed ? "42px" : "auto"}
                className={collapsed ? "border-rounded" : "null"}
              />
            </div>
          }
        >
          <Menu theme="dark" mode="inline">
            <Menu.Item key="1" icon={<BsSoundwave size="25" />}>
              <Link to="/dashboard">Dashboard</Link>
            </Menu.Item>
            <Menu.Item key="2" icon={<FaHardHat size="25" />}>
              <Link to="/contractors">Customers</Link>
            </Menu.Item>
            <Menu.Item key="3" icon={<GiMineTruck size="25" />}>
              <Link to="/rmx">Asphalt Plants</Link>
            </Menu.Item>
            <Menu.Item key="4" icon={<RiTruckLine size="25" />}>
              <Link to="/logistics">Logistics Plants </Link>
            </Menu.Item>
            <Menu.Item key="5" icon={<HiUserCircle size="25" />}>
              <Link to="/employees">Employees</Link>
            </Menu.Item>
            <Menu.Item key="6" icon={<HiOutlineDocumentDuplicate size="25" />}>
              <Link to="/product">Catalog</Link>
            </Menu.Item>
            <Menu.Item key="7" icon={<AiFillTool size="25" />}>
              <Link to="/account">Account</Link>
            </Menu.Item>
            <Menu.Item
              key="8"
              icon={<RiLogoutBoxRLine size="25" />}
              onClick={() => {
                localStorage.clear();
                window.location.reload();
              }}
            >
              logout
            </Menu.Item>
          </Menu>
        </Drawer>
      ) : (
        <SideMenuWrapper
          trigger={null}
          collapsible
          collapsed={collapsed}
          style={{
            overflow: "auto",
            height: "100vh",
            position: "sticky",
            top: 0,
            left: 0,
            zIndex: "10000000",
          }}
        >
          <div style={{ backgroundColor: "black", height: '3em' }}>
            <img
              src={
                collapsed ? StLogo : Logo
              }
              width={collapsed ? "40px" : "170px"}
              height={collapsed ? "40px" : "40px"}
              className={collapsed && "border-rounded"}
              style={{ backgroundPosition: 'center center', objectFit: !collapsed && 'contain' }}
            />
          </div>{" "}
          <Menu
            theme="dark"
            mode="inline"
            defaultSelectedKeys={key}
            className={!collapsed ? "custom" : "collapsed-custom"}
            // onClick={()=>DashboardAction.plant}
            onClick={(e) =>
              dispatch(DashboardAction.getPlantTabProductKeyReq(e?.key))
            }
            selectedKeys={plantkeyTab}
          >
            <Menu.Item key="1" icon={<BsSoundwave size="25" />}>
              <Link to="/dashboard">Dashboard</Link>
            </Menu.Item>
            <Menu.Item key="2" icon={<FaHardHat size="25" />}>
              <Link to="/contractors">Customers</Link>
            </Menu.Item>
            <Menu.Item key="3" icon={<GiMineTruck size="25" />}>
              <Link to="/rmx">Asphalt Plants</Link>
            </Menu.Item>
            <Menu.Item key="4" icon={<RiTruckLine size="25" />}>
              <Link to="/logistics">Logistics Plants </Link>
            </Menu.Item>
            <Menu.Item key="5" icon={<HiUserCircle size="25" />}>
              <Link to="/employees">Employees</Link>
            </Menu.Item>
            <Menu.Item key="6" icon={<HiOutlineDocumentDuplicate size="25" />}>
              <Link to="/product">Catalog</Link>
            </Menu.Item>
            <Menu.Item key="7" icon={<AiFillTool size="25" />}>
              <Link to="/account">Account</Link>
            </Menu.Item>
            <Menu.Item
              key="8"
              icon={<RiLogoutBoxRLine size="25" />}
              onClick={() => {
                localStorage.clear();
                window.location.reload();
              }}
            >
              logout
            </Menu.Item>
          </Menu>
        </SideMenuWrapper>
      )}

      <Layout className="site-layout">
        {isWide ? (
          <header class="st-bg-header">
            <h2
              class={
                collapsed
                  ? "page-heading left  "
                  : "page-heading left active-sidenav"
              }
              style={{ display: "inline-block" }}
            >
              <span>
                <i class="left material-icons">
                  {addressName === "Update Product" ||
                    addressName === "Update Basemix" ||
                    addressName === "Update Additive" ||
                    addressName === "Update Category" ||
                    addressName === "Create New Product" ||
                    addressName === "Create New Basemix" ||
                    addressName === "Create New Additive" ||
                    addressName === "Create New Category" ||
                    addressName === "Order" ? (
                    <BsArrowLeftShort
                      style={{
                        float: "left",
                        marginLeft: "-0.5rem",
                        marginTop: "-3px",
                      }}
                      color="white"
                      size={"30"}
                      onClick={() => {
                        if (addressName === "Order") {
                          history.goBack();
                        } else {
                          history.push({
                            pathname: "/product",
                            state: { activeKey: tabKey },
                          });
                        }
                      }}
                      className="pointer-cursor"
                    />
                  ) : (
                    <AiOutlineMenu
                      style={{
                        float: "left",
                        marginTop: "-3px",
                        padding: "5px",
                      }}
                      className="pointer-cursor"
                      color="white"
                      size={"30"}
                      onClick={toggle}
                    />
                  )}
                </i>
              </span>
              <span class="icon-btn"></span>
              {addressName}
              {/* {!componentName.includes("orders") && addressName} */}
            </h2>
            {isWide && (
              <div class=" right" style={{ display: "flex" }}>
                <Dropdown
                  overlay={menu}
                  trigger={["click"]}
                  overlayClassName="notification-dropdown-class"
                >
                  <Badge
                    count={markAsRead.length}
                    style={{ backgroundColor: "#f9a01b" }}
                    size="small"
                    offset={[-20, 5]}
                  >
                    <AiFillBell
                      color="white"
                      size={"20"}
                      onClick={() => setIsVisible(!isVisible)}
                      className="pointer-cursor"
                      style={{ marginRight: "10px", marginTop: "1.5px" }}
                    />
                  </Badge>
                </Dropdown>{" "}
                <span style={{ color: "white", marginRight: "10px" }}>
                  Welcome{" "}
                  <a class="orange-text">
                    {" "}
                    {`${userName[0]?.user?.first_name || "-"} ${userName[0]?.user?.last_name || "-"
                      }`}
                  </a>
                </span>
              </div>
            )}
          </header>
        ) : (
          <Row
            style={{
              width: "100%",
              height: "3rem",
              position: "fixed",
              zIndex: "1",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundImage: `url(${HeaderImage})`,
            }}
            align="middle"
            justify="space-between"
          >
            <Col span={24}>
              <Row align="middle" justify="start">
                <Col xs={3} sm={2}>
                  {addressName === "Update Product" ? (
                    <BsArrowLeftShort
                      style={{
                        float: "left",
                        marginLeft: "0.5rem",
                      }}
                      color="white"
                      size={"30"}
                      onClick={() => history.push("/product")}
                      className="pointer-cursor"
                    />
                  ) : (
                    <AiOutlineMenu
                      style={{
                        float: "left",
                        marginLeft: "0.5rem",
                      }}
                      className="pointer-cursor"
                      color="white"
                      size="25"
                      onClick={toggle}
                    />
                  )}
                </Col>
                <Col xs={18} sm={18}>
                  <h2 className="text-white text-capitilize text-left">
                    {!componentName.includes("order") ? addressName : null}
                  </h2>
                </Col>
              </Row>
            </Col>
            {isWide && (
              <Col xl={11} xs={18} sm={11} md={12} lg={12}>
                <Row
                  id="toggle-id"
                  justify={!collapsed ? "center" : "end"}
                  align="middle"
                  style={{ marginRight: "65px" }}
                >
                  <Col xl={1} xs={1} sm={2} lg={2} md={1}>
                    <Dropdown
                      overlay={menu}
                      trigger={["click"]}
                      overlayClassName="notification-dropdown-class"
                    >
                      <Badge
                        count={markAsRead.length}
                        style={{ backgroundColor: "#f9a01b" }}
                        size="small"
                        offset={[-20, 5]}
                      >
                        <AiFillBell
                          color="white"
                          size={"25"}
                          onClick={() => setIsVisible(!isVisible)}
                          className="pointer-cursor"
                        />
                      </Badge>
                    </Dropdown>
                  </Col>
                  <Col xl={2} xs={1} sm={5} md={5} lg={2}>
                    <span
                      // className="color-white"
                      style={{ color: "white" }}
                    >
                      Welcome
                    </span>
                  </Col>
                  <Col xl={4} xs={18} sm={7} md={5} lg={4}>
                    <span
                      className="text-right three-dot"
                      style={{ color: "orange" }}
                    >
                      {`${userDetail?.first_name || "-"} ${userDetail?.last_name || "-"
                        }`}
                    </span>
                  </Col>
                </Row>
              </Col>
            )}
          </Row>
        )}

        <Content
          className="site-layout-background"
          style={{
            margin: "20px 0px",
            padding: 24,
            minHeight: 280,
          }}
        >
          {props.children}
        </Content>
      </Layout>
    </Layout>
  );
}
export default SideMenu;
